import BaseModal from '@/components/BaseModal';
import SelectLocationCondition from '@/components/ModalLocationCondition/SelectLocationCondition';
import { USER_GUIDE_LINK } from '@/constants/path';
import { IConditionValue, IItemCondition, ILocationCondition } from '@/types/newSetup.type';
import { Link } from '@shopify/polaris';
interface IProps {
  isOpenModal: boolean;
  setIsOpenModal: (isOpenModal: boolean) => void;
  onAdd: (key: IItemCondition['type'] | ILocationCondition['type']) => (value: IConditionValue[] | null) => void;
  data: ILocationCondition[];
  isInCheckout?: boolean;
}

const ModalLocationCondition = ({ isOpenModal, setIsOpenModal, onAdd, data, isInCheckout }: IProps) => {
  return (
    <BaseModal
      title="Select a location condition"
      open={isOpenModal}
      onClose={() => {
        setIsOpenModal(false);
      }}
      size="large"
    >
      <SelectLocationCondition data={data} isInCheckout={isInCheckout} setIsOpenModal={setIsOpenModal} onAdd={onAdd} />

      <div className="mt-12">
        <Link url={USER_GUIDE_LINK.RULE_SETUP} target="_blank" removeUnderline>
          Learn more about display conditions
        </Link>
      </div>
    </BaseModal>
  );
};

export default ModalLocationCondition;
